import { createContext, useContext, useState, ReactNode, useCallback } from "react";

interface AuthContextType {
  isAuthenticated: boolean;
  login: (password: string) => boolean;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

const isBrowser = typeof window !== "undefined" && typeof sessionStorage !== "undefined";

export function AuthProvider({ children }: { children: ReactNode }) {
  // Use session storage to persist login state across refreshes, but clear on browser close
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    if (!isBrowser) return false;
    return sessionStorage.getItem("admin_auth") === "true";
  });

  const login = useCallback((password: string) => {
    // Hardcoded password for mockup purposes
    if (password === "Admin!23") {
      setIsAuthenticated(true);
      if (isBrowser) {
        sessionStorage.setItem("admin_auth", "true");
      }
      return true;
    }
    return false;
  }, []);

  const logout = useCallback(() => {
    setIsAuthenticated(false);
    if (isBrowser) {
      sessionStorage.removeItem("admin_auth");
      window.location.href = "/login";
    }
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
